import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProcurementFile } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import DropItem from 'modules/procurement/components/DropItem'

interface Props {
  files: ProcurementFile[]
  purchaseRequestId: number
}

const Attachments = ({ files }: Props) => {
  return files.length > 0 ? (
    <Box paddingTop="s24" gap="s12">
      {files.map((file: ProcurementFile) => (
        <DropItem key={file.filename} file={file} />
      ))}
    </Box>
  ) : (
    <Box justifyContent="center" alignItems="center" textAlign="center" paddingTop="s24" gap="s12">
      <Text.Normal size="200">
        {i18n.t('procurement.purchase_requests.detail.attachments.empty')}
      </Text.Normal>
    </Box>
  )
}

export default Attachments
